import { render } from "./ExamResultModal.vue?vue&type=template&id=66661c73&scoped=true"
import script from "./ExamResultModal.vue?vue&type=script&lang=js"
export * from "./ExamResultModal.vue?vue&type=script&lang=js"

import "./ExamResultModal.vue?vue&type=style&index=0&id=66661c73&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66661c73"]])

export default __exports__